// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EG2bL","container":"Footer_container__HFjzt","text":"Footer_text__mLRas","privacyLink":"Footer_privacyLink__1J4oC"};